import React from 'react';
import Header from '../Components/Header/Header';
import About from '../Components/About/About';
import Footer from '../Components/Footer/Footer';



const HomePage = () => {
  return (
    <div>
      <Header />
      <About/>
      <Footer />
      
    </div>
  );
};

export default HomePage;
